module.exports = __webpack_public_path__ + "static/media/U1-T2-4-2.cb8d67ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-4-2.svg
// module id = 588
// module chunks = 0